// import  logout  from "../redux/Slice/authSlice";
// import InactivityDetector from "../global/helper";
import { Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { Suspense, lazy } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import Loader from "../components/Loader";
import Header from "../components/Header";
import Footer from "../components/Footer";
const Home = lazy(() => import("../pages/Home"));
// const StudentLogin = lazy(() => import("../pages/StudentLogin"));
const Signup = lazy(() => import("../pages/Signup"));
const VerifyOtp = lazy(() => import("../pages/VerifyOtp"));
const ForgotPassword = lazy(() => import("../pages/ForgotPassword"));
const ResetPassword = lazy(() => import("../pages/ResetPassword"));
const UniversityTable = lazy(() => import("../pages/UniversityData"));
const StudentProfileForm = lazy(() => import("../pages/StudentProfileForm"));
const AboutUs = lazy(() => import("../pages/AboutUs"));
const Courses = lazy(() => import("../pages/Courses"));
const CoursesDetail = lazy(() => import("../pages/CoursesDetail"));
const TermCondition = lazy(() => import("../pages/TermCondition"));
const StudentProfileDataTable = lazy(() =>
  import("../pages/StudentProfileData")
);
const StudentApplications = lazy(() => import("../pages/StudentData"));
const ComingSoon = lazy(() => import("../pages/ComingSoon"));

const PrivateRoute = () => {
  const token = useSelector((state) => state.info.token);
  // If token exists, allow access to the route
  return token ? <Outlet /> : <Navigate to="/signup" />;
};

// const handleInactivity = () => {
//   if (token) {
//     dispatch(logout());
//     alert("Your session has expired. Please log in again to continue."); // Show session expired alert
//     window.location.href = "/";
//     }
//   }

const Router = () => {
  // const token = useSelector((state) => state.info.token);
  // const role = useSelector((state) => state?.info?.user?.role);
  // const navigate = useNavigate();
  // useEffect(() => {
  //   if (token) {
  //     if (role === "student") {
  //       navigate("/get-all-universities");
  //     } else {
  //       navigate("/student-data");
  //     }
  //   } else {
  //     navigate("/signup");
  //   }
  // }, [token]);

  return (
    <>
      <ToastContainer />
      <div className="min-h-screen flex flex-col justify-between">
        <Header />
        <div className="">
          <Suspense fallback={<Loader />}>
            {/* <InactivityDetector onInactivity={handleInactivity} timeout={3000} /> */}
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<Home />} />
              <Route path="/about-us" element={<AboutUs />} />
              <Route path="/courses" element={<Courses />} />
              {/* <Route path="/login" element={<StudentLogin />} /> */}
              <Route path="/course-detail" element={<CoursesDetail />} />
              <Route path="/term-and-condition" element={<TermCondition />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/verify-Otp" element={<VerifyOtp />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/coming-soon" element={<ComingSoon />} />

              {/* Private Routes */}
              <Route element={<PrivateRoute />}>
                <Route
                  path="/get-all-universities"
                  element={<UniversityTable />}
                />
                <Route path="/student-form" element={<StudentProfileForm />} />

                <Route path="/student-data" element={<StudentApplications />} />
                <Route
                  path="/student-profile"
                  element={<StudentProfileDataTable />}
                />
                <Route
                  path="/get-all-student-applications"
                  element={<StudentProfileDataTable />}
                />
                {/* Add more protected routes here if needed */}
              </Route>
            </Routes>
          </Suspense>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default Router;
